// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-HeaderCellLabel_cls1__EEbXz","cls2":"VeloTable-HeaderCellLabel_cls2__gjW26 VeloTable-HeaderCellLabel_cls1__EEbXz"};